import fulllogo from './../../assets/img/FullLogo.svg'
import logo from './../../assets/img/Logo.svg'

export function Logo({ className }: { className?: string }) {
  return <img className={className} src={logo} alt="Pure Wave Logo" />
}

export function FullLogo({ className }: { className?: string }) {
  return <img className={className} src={fulllogo} alt="Pure Wave Logo" />
}
